import React, { Component } from 'react';

class ModalConfirmarEliminacionModelos extends Component {

    constructor(props) {
        super(props);
    }
    

    render() {
        const {
            valorComboMarcaTemporal
        } = this.props;

        //ACTIONS
        const {
            limpiarModelosSeleccionados,
            mostrarOcultarModalAsientosContables
        } = this.props;

        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS AsientosContables__modalConfirmarEliminacionModelosSeleccionados'>
                    <div className='text-right'>
                        <label onClick={() => mostrarOcultarModalAsientosContables("modalConfirmarEliminacionModelos", false)} className='ti-close clickable modalProcesosClose AsientosContables__modalConfirmarEliminacionModelosSeleccionados__botonCerrar'></label>        
                    </div>

                    <div className='modalConfirmarSalirTexto AsientosContables__modalConfirmarEliminacionModelosSeleccionados__mensaje'>
                        ¿Está seguro que desea cambiar de Marca y limpiar los modelos seleccionados?
                    </div>

                    <div className='modalProcesosFooterShort'>
                        <button onClick={() => mostrarOcultarModalAsientosContables("modalConfirmarEliminacionModelos", false)} className="btn btn-secondary">Cancelar</button>
                        <button className="btn btn-cta" onClick={() => limpiarModelosSeleccionados(valorComboMarcaTemporal)}>Confirmar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalConfirmarEliminacionModelos;